import { render, staticRenderFns } from "./properties.vue?vue&type=template&id=079539c0&scoped=true"
import script from "./properties.vue?vue&type=script&lang=js"
export * from "./properties.vue?vue&type=script&lang=js"
import style0 from "./properties.vue?vue&type=style&index=0&id=079539c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079539c0",
  null
  
)

export default component.exports